Date.prototype.addHours = function (h) {
  this.setTime(this.getTime() + h * 60 * 60 * 1000);
  return this;
};

export function getDatePlusHours(datex, hours) {
  let date = new Date(datex);
  date.addHours(hours);
  console.log(date.toLocaleDateString());
  return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
}
